"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TableTdInfo = _styledComponents["default"].td.attrs(function () {
  return {
    id: "best-table-td-info"
  };
}).withConfig({
  displayName: "TableTdInfo",
  componentId: "sc-1mffv53-0"
})(["&&&{background-color:#f2f3f4 !important;font-weight:bold !important;width:150px;vertical-align:middle;padding:0.5rem;"]);

var _default = TableTdInfo;
exports["default"] = _default;